module.exports = __webpack_public_path__ + "static/media/plus.46e0a872.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Matches/plus.svg
// module id = 360
// module chunks = 0